import { render, staticRenderFns } from "./highlighted-article.vue?vue&type=template&id=31f33a72"
import script from "./highlighted-article.vue?vue&type=script&lang=js"
export * from "./highlighted-article.vue?vue&type=script&lang=js"
import style0 from "./highlighted-article.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports